import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { HttpService } from '@services/http.service';
import { StringDto } from '@models/basic/string-dto';
import { ConfirmResetPassword } from '@models/security/confirm-reset-password';
import { EndpointParams } from '@models/utils/endpoint-params';

@Injectable({
    providedIn: 'root'
})
export class SecurityService extends HttpService {
    private readonly defaultEndpointParams: EndpointParams = { app: 'member', version: 1 };

    setRecoverPassword(emailString: StringDto, publicToken: string): Observable<any> {
        const url = `members/password/recovery?centerToken=${publicToken}`;

        return this.post(url, this.defaultEndpointParams, emailString);
    }

    resetPassword(confirmResetPassword: ConfirmResetPassword, publicToken: string): Observable<any> {
        const url = `members/password/reset?centerToken=${publicToken}`;

        return this.post(url, this.defaultEndpointParams, confirmResetPassword);
    }
}
